import { getHeaders, checkStatus,checkAWSLoginStatus } from "../../../shared/services/shared";
import bcrypt from 'bcryptjs';
/**
 * Login Service
 * @param {*} username
 * @param {*} password
 * 
 */
export async function login(username, password, override = false) {
  let headers = await getHeaders({}, ['Content-Type', 'hosttoken']);
  let params = {
    "username": username,
    "password": password
  }
  if (override) {
    params.override = override;
  }
  // VAPT fixes, payload hash is sent with actual payload
  const saltRounds = 10;
  const plainText = JSON.stringify(params);
  const hashToken = bcrypt.hashSync(plainText, saltRounds);
  params["token"] = hashToken;
  return fetch(`${process.env.REACT_APP_API_URL}/user/login`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(params)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("HTTP error, status = " + response.status);
      }
      return response.json()
    })
    .then(checkStatus)
    .catch(error => {
      return Promise.reject(error)
    })
}
/**
 * Forget Password
 * @param {*} username 
 */
export async function forgetPassword(username) {
  let headers = await getHeaders({}, ['Content-Type', 'hosttoken']);
  return fetch(`${process.env.REACT_APP_API_URL}/user/forgetpassword`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ "username": username })

  })
    .then(response => {
      if (!response.ok) {
        throw new Error("HTTP error, status = " + response.status);
      }
      return response.json()
    })
    .then(checkStatus)
    .catch(error => {
      return Promise.reject(error)
    })
}
/**
 * My Tickets
 */
export async function mytickets(params) {
  let body = {
    "page": params.page,
    "perpage": params.count,
    "Email": params.email,
    "CaseNumber": params.search,
    "component": params.component,
  };
  if (params.orderBy) {
    body.orderBy = params.orderBy;
  }
  let headers = await getHeaders();
  return fetch(`${process.env.REACT_APP_API_URL}/salesforce/data`, {
    accept: "application/json",
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("HTTP error, status = " + response.status);
      }
      return response.json()
    })
    .catch(error => {
      return Promise.reject(error)
    })
}
export async function createTicket(data) {
  let headers = await getHeaders();
  return fetch(`${process.env.REACT_APP_API_URL}/salesforce/data/createticket`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify({
      "Category": data.problemtype,
      "Subject": data.subject,
      "Description": data.description,
      "Email": data.email,
      "component": data.component,
      "Status": data.status
    })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("HTTP error, status = " + response.status);
      }
      return response.json()
    }).then(checkStatus)
    .catch(error => {
      return Promise.reject(error)
    })
}
export async function TokenValidation(token) {
  return fetch(`${process.env.REACT_APP_API_URL}/user/token/status`, {
    method: 'POST',
    headers: {
      'Content-Type': "application/json",
      'Cache-Control': 'no-cache',
      "Authorization": token
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("HTTP error, status = " + response.status);
      }
      return response.json()
    }).then(checkStatus)
    .catch(error => {
      return Promise.reject(error)
    })
}
export async function resetPassword(password, token) {
  let params = { "password": password };
  // VAPT fixes, payload hash is sent with actual payload
  const saltRounds = 10;
  const plainText = JSON.stringify(params);
  const hashToken = bcrypt.hashSync(plainText, saltRounds);
  params["token"] = hashToken;
  return fetch(`${process.env.REACT_APP_API_URL}/user/createPassword`, {
    method: 'POST',
    headers: {
      'Content-Type': "application/json",
      'Cache-Control': 'no-cache',
      'Authorization': token
    },
    body: JSON.stringify(params)

  })
    .then(response => {
      if (!response.ok) {
        throw new Error("HTTP error, status = " + response.status);
      }
      return response.json()
    }).then(checkStatus)
    .catch(error => {
      return Promise.reject(error)
    })
}
export async function getMenu() {
  let headers = await getHeaders();
  return fetch(`${process.env.REACT_APP_API_URL}/user/menu`, {
    method: 'GET',
    headers: headers
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("HTTP error, status = " + response.status);
      }
      return response.json()
    }).then(checkStatus)
    .catch(error => {
      return Promise.reject(error)
    })
}
export async function getTenantInfo() {
  return fetch(`${process.env.REACT_APP_API_URL}/tenant`, {
    method: 'GET',
    headers: {
      'Content-Type': "application/json",
      'Cache-Control': 'no-cache',
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("HTTP error, status = " + response.status);
      }
      return response.json()
    })
    .then(checkStatus)
    .catch(error => {
      return Promise.reject(error)
    })
}
export async function logout() {
  let tenantConfig = JSON.parse(sessionStorage.getItem('tenantConfig'));
  let AWSCode = sessionStorage.getItem('AWSCode');
  let headers = await getHeaders();
  return fetch(`${process.env.REACT_APP_API_URL}/user/logout`, {
    accept: "application/json",
    method: 'POST',
    headers: headers
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("HTTP error, status = " + response.status);
      }
      if(tenantConfig.logoutUrl && AWSCode){
        window.location.href= tenantConfig.logoutUrl;
      }
      return response.json()
    })
    .catch(error => {
      return Promise.reject(error)
    })
}
export async function validateOtp(param, sessionid) {
  return fetch(`${process.env.REACT_APP_API_URL}/user/mfa/verify`, {
    method: 'POST',
    headers: await getHeaders(
      {
        'Content-Type': 'application/json',
        'sessionId': sessionid
      }
    ),
    body: JSON.stringify(param)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("HTTP error, status = " + response.status);
      }
      return response.json()
    }).then(checkStatus)
    .catch(error => {
      return Promise.reject(error)
    })
}
export async function resendOtp(param, sessionid) {
  return fetch(`${process.env.REACT_APP_API_URL}/user/mfa/resend/otp`, {
    method: 'POST',
    headers: await getHeaders(
      {
        'Content-Type': 'application/json',
        'sessionId': sessionid
      }
    ),
    body: JSON.stringify(param)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("HTTP error, status = " + response.status);
      }
      return response.json()
    }).then(checkStatus)
    .catch(error => {
      return Promise.reject(error)
    })
}
export async function userFeedback(param) {
  let headers = await getHeaders();
  return fetch(`${process.env.REACT_APP_API_URL}/user/feedback`, {
    accept: "application/json",
    method: 'POST',
    headers: {...headers, 
      "component":"/user/feedback"
    },
    body: JSON.stringify(param)
  }).then(response => {
    if (!response.ok) {
      throw new Error("HTTP error, status = " + response.status);
    }
    return response.json()
  }).then(checkStatus)
    .catch(error => {
      return Promise.reject(error)
    })
}

export async function AWSLogin(param) {
  return fetch(`${process.env.REACT_APP_API_URL}/cognito/login?code=${param.code}`, {
    accept: "application/json",
    method: 'GET',
    headers: {
      "hosttoken": param.hosttoken
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("HTTP error, status = " + response.status);
    }
    return response.json()
  }).then(checkAWSLoginStatus).then(res=>{
    return res;
  })
    .catch(error => {
      return Promise.reject(error)
    })
}

export async function sendCodeWithSessionId(param) {
  return fetch(`${process.env.REACT_APP_BOT_API_URL}/sso/login?code=${param.code}&sessionid=${param.sessionid}`, {
    accept: "application/json",
    method: 'GET',
  }).then(response => {
    if (!response.ok) {
      throw new Error("HTTP error, status = " + response.status);
    }
    return response.json()
  }).then(checkAWSLoginStatus).then(res=>{
    return res;
  })
    .catch(error => {
      return Promise.reject(error)
    })
}




